import { useEffect, useState } from "react";
import Footer from "../../../components/Footer/Footer";
import Header from "../../../components/Header/Header";
import { useNavigate, useParams } from "react-router-dom";
import TeachersCommunitySection from "../../../components/Community-section/Techers-Section";
import MembersCommunitySection from "../../../components/Community-section/Members-Section";
import HeadSection from "../../../components/meta";

const CommunityCategory = () => {
  const { cat } = useParams();
  const category = cat === "" || cat === null ? "top_menu" : cat;

  const navigate = useNavigate();

  const [activeSection, setActiveSection] = useState("community");
  useEffect(() => {
    if (category === "") {
      return navigate("/community");
    } else {
      //   setActiveSection("community");
    }
  }, [category, navigate]);
  return (
    <>
      <HeadSection
        title={`${category.toLocaleUpperCase()} | COMMUNITY`}
        keywords={""}
        addPostFixTitle={true}
        largeTwitterCard={true}
        showCanonical={true}
        content={
          "Join the Seed to Tree Online Academy and unlock your potential. Connect with a vibrant community of learners and educators. Discover engaging courses, develop in-demand skills, and make a lasting impact"
        }
        link={`/community/${category}`}
      />

      <Header isActive={activeSection} />
      <div className="community-page">
        <section className="community-sections">
          {category === "teacher" ? (
            <TeachersCommunitySection setActiveSection={setActiveSection} />
          ) : category === "member" ? (
            <MembersCommunitySection setActiveSection={setActiveSection} />
          ) : (
            <h3>Nothing Found!!!</h3>
          )}
        </section>
      </div>
      <Footer />
    </>
  );
};

export default CommunityCategory;
